var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 119.86,
    cy: 119.52,
    r: 119.02,
    fill: "#F7BBC3",
    stroke: "#F7BBC3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3402 101.729C25.3402 147.21 63.1282 171.442 90.783 193.139C100.54 200.789 109.94 208 119.34 208C128.74 208 138.14 200.799 147.897 193.13C175.562 171.451 213.34 147.21 213.34 101.739C213.34 56.2582 161.64 24.0019 119.34 67.7335C77.0402 23.9926 25.3402 56.2488 25.3402 101.729Z",
    fill: "#F499A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/Group 1.6861471e9a7d1fa284a0c9e343f1fa4b.svg";
export { ForwardRef as ReactComponent };